import { ActivatedRoute, Router } from '@angular/router';
var ComponentEvaluate = (function () {
    function ComponentEvaluate(route, router) {
        this.route = route;
        this.router = router;
    }
    ComponentEvaluate.prototype.ngOnInit = function () {
    };
    ComponentEvaluate.prototype.ngAfterViewInit = function () {
    };
    return ComponentEvaluate;
}());
export { ComponentEvaluate };



// WEBPACK FOOTER //
// ./src/component/evaluate/component.evaluate.ts.pre-build-optimizer.js